import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export const authConfig: AuthConfig = {
  clientId: 'cmt',
  redirectUri: window.location.origin,
  scope: 'read write',
  responseType: 'token',
  oidc: false,
  showDebugInformation: !environment.production,
  loginUrl: `${environment.authUrl}/oauth/authorize`,
  logoutUrl: `${environment.authUrl}/ssologout`,
  tokenEndpoint: `${environment.authUrl}/oauth/token`,
  disablePKCE: true,
  sessionChecksEnabled: false,
};

/** Role required to access AMIE — see EB-3775. */
export const REQUIRED_ROLE = 'ROLE_EBUERO_EMPLOYEE';
